import React from 'react'
import PageHero from '../components/PageHero'
import PageLayout from '../components/PageLayout'

const Photos: React.FC = () => {
    return (
        <PageLayout>
            <PageHero title="Photos From Our Events" image="./img/communityheader.jpg" imageAlt="Community members at a House event" />
            <section className="py-5">
                <div className="container text-center">
                    <h2>Gallery coming soon</h2>
                    <p className="lead readable-copy">We are gathering highlights from our community events. Check back soon.</p>
                </div>
            </section>
        </PageLayout>
    )
}

export default Photos
